import { twMerge } from 'tailwind-merge'

export const PlayerLoader = ({ className }) => (
	<div className={twMerge('flex flex-col w-full h-full bg-bg-dark-1 rounded-lg p-4 gap-3', className)}>
		<div className="animate-skeleton-loading bg-dark-2 w-full flex-1 rounded-lg" />
	</div>
)
